export const cardContainer = {
  id: 'card',
  schema: {
    type: 'object',
    properties: {},
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'card',
    uiType: 'container',
    title: 'Card',
    fieldName: 'Card',
    isCanEdit: true,
    isCanDelete: true,
    cardColor: '#4099ff',
    textColor: 'black',
    action: { event: '', name: '' },
    elements: [],
    formData: false,
  },
}

export const collapseContainer = {
  id: 'collapse',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'collapse',
    uiType: 'container',
    title: 'Collapse',
    fieldName: 'Collapse',
    isCanEdit: true,
    isCanDelete: true,
    cardColor: '#4099ff',
    textColor: 'black',
    openCollapse: false,
    stickyCollapse: false,
    action: { event: '', name: '' },
    elements: [],
    formData: false,
  },
}

export const panelContainer = {
  id: 'panel',
  schema: {
    type: 'object',
    properties: {},
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'panel',
    uiType: 'container',
    title: 'Panel',
    fieldName: 'Panel',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    elements: [],
    formData: false,
  },
}

export const modalContainer = {
  id: 'modal',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'modal',
    uiType: 'container',
    title: 'Modal',
    fieldName: 'Modal',
    isCanEdit: true,
    isCanDelete: true,
    cardColor: '#4099ff',
    textColor: 'black',
    action: { event: '', name: '' },
    formData: false,
    part: {
      modalBody: {
        id: 'modalBody',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          uiType: 'container',
          title: 'Modal',
          fieldName: 'Modal Body',
          type: 'Group',
          label: '',
          name: 'modalBody',
          isCanEdit: true,
          isCanDelete: false,
          elements: [],
        },
      },
      modalFooter: {
        id: 'modalFooter',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          uiType: 'container',
          title: 'Modal',
          fieldName: 'Modal Footer',
          type: 'Group',
          label: '',
          name: 'modalFooter',
          isCanEdit: true,
          isCanDelete: false,
          elements: [],
        },
      },
    },
    elements: [],
  },
}

export const tabContainer = {
  id: 'tab',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'tab',
    uiType: 'container',
    title: 'Tab',
    fieldName: 'Tab',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    formData: false,
    isKeepTabRender: true,
    part: {
      tabPanel: {
        id: 'tabPanel',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          type: 'Group',
          label: '',
          name: 'tabPanel',
          uiType: 'container',
          title: 'Tab',
          fieldName: 'Tab Panel',
          elements: [],
          isCanEdit: true,
          isCanDelete: true,
        },
      },
    },
    elements: [],
  },
}

export const tabPanelContainer = {
  id: 'tabPanel',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'tabPanel',
    uiType: 'container',
    title: 'Tab',
    fieldName: 'Tab Panel',
    elements: [],
    isCanEdit: true,
    isCanDelete: true,
    formData: false,
  },
}

export const dynamicContainer = {
  id: 'dynamic',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'dynamic',
    uiType: 'container',
    title: 'Dynamic',
    fieldName: 'Dynamic',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    formData: false,
    cardColor: 'white',
    panelPattern: 'down',
    firstDelete: false,
    buttonPosition: 'center',
    panelWidth: '100%',
    part: {
      dynamicPanel: {
        id: 'dynamicPanel',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          type: 'Group',
          label: '',
          name: 'dynamicPanel',
          uiType: 'container',
          title: 'Dynamic',
          fieldName: 'Dynamic Panel',
          elements: [],
          isCanEdit: true,
          isCanDelete: true,
        },
      },
      editPanel: {
        id: 'editPanel',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          type: 'Group',
          label: '',
          name: 'editPanel',
          uiType: 'container',
          title: 'Edit Panel',
          fieldName: 'Edit Panel',
          elements: [],
          isCanEdit: true,
          isCanDelete: true,
        },
      },
    },
    elements: [],
  },
}

export const dynamicPanelContainer = {
  id: 'dynamicPanel',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'dynamicPanel',
    uiType: 'container',
    title: 'Dynamic',
    fieldName: 'Dynamic Panel',
    elements: [],
    isCanEdit: true,
    isCanDelete: true,
  },
}

export const editPanelContainer = {
  id: 'editPanel',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'editPanel',
    uiType: 'container',
    title: 'Edit Panel',
    fieldName: 'Edit Panel',
    elements: [],
    isCanEdit: true,
    isCanDelete: true,
  },
}

export const panelGroupContainer = {
  id: 'panelGroup',
  schema: {
    type: 'object',
  },
  uischema: {
    layoutWidth: '12',
    labelWidth: 'auto',
    type: 'Group',
    label: '',
    name: 'panelGroup',
    uiType: 'container',
    title: 'Panel Group',
    fieldName: 'Panel Group',
    isCanEdit: true,
    isCanDelete: true,
    action: { event: '', name: '' },
    formData: true,
    isArray: true,
    part: {
      panel: {
        id: 'panel',
        schema: {
          type: 'object',
        },
        uischema: {
          layoutWidth: '12',
          labelWidth: 'auto',
          type: 'Group',
          label: '',
          name: 'panel',
          uiType: 'container',
          title: 'Panel',
          fieldName: 'Panel',
          elements: [],
          isCanEdit: true,
          isCanDelete: true,
        },
      },
    },
    elements: [],
  },
}

export const staticContainer = [
  cardContainer,
  collapseContainer,
  panelContainer,
  modalContainer,
  tabContainer,
  dynamicContainer,
  panelGroupContainer,
  // {
  //   id: 'rowCard',
  //   schema: {
  //     type: 'object',
  //     properties: {},
  //   },
  //   uischema: {
  //     layoutWidth: '12',
  //     labelWidth: 'auto',
  //     type: 'Group',
  //     label: '',
  //     name: 'rowCard',
  //     uiType: 'container',
  //     title: 'Row Card',
  //     fieldName: 'Row Card',
  //     isCanEdit: true,
  //     isCanDelete: true,
  //     cardColor: '#4099ff',
  //     textColor: 'black',
  //     action: { event: '', name: '' },
  //     elements: [],
  //     formData: false,
  //   },
  // },
]

export const staticSubContainer = [tabPanelContainer, dynamicPanelContainer]

export const convertContainerSchema = {
  tab: 'tab',
}

export const convertContainer = [
  { title: cardContainer.uischema.fieldName, value: cardContainer.id },
  {
    title: collapseContainer.uischema.fieldName,
    value: collapseContainer.id,
  },
  { title: panelContainer.uischema.fieldName, value: panelContainer.id },
  { title: tabContainer.uischema.fieldName, value: tabContainer.id },
  {
    title: tabPanelContainer.uischema.fieldName,
    value: tabPanelContainer.id,
  },
]
